import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearSession } from '../../modules/auth';

import './topnav.css';

const TopNav = ({ user, clearSession: handleClearSession, history }) => {
  const isAdmin = user && Array.isArray(user.roles) && user.roles.indexOf('admin') !== -1;
  const displayName = (user && (user.name || user.username || user.email)) || 'Guest user';
  const avatarLetter = displayName.charAt(0).toUpperCase();
  const displayRole = isAdmin ? 'Admin' : 'Member';

  const handleLogout = () => {
    handleClearSession();
    if (history && typeof history.push === 'function') {
      history.push('/');
    }
  };

  const handleOpenAccount = () => {
    if (history && typeof history.push === 'function') {
      history.push('/account');
    }
  };

  const handleGoHome = () => {
    if (history && typeof history.push === 'function') {
      history.push('/');
    }
  };

  return (
    <header className="top-nav">
      <button
        type="button"
        className="top-nav__logo"
        onClick={handleGoHome}
        aria-label="Go to home page"
      >
        SO<span className="top-nav__logo-accent">A</span>L
        <span className="top-nav__logo-accent">I</span>VE
      </button>
      <div className="top-nav__actions">
        {user && (
          <>
            {isAdmin && (
              <button
                type="button"
                className="ghost-btn ghost-btn--text"
                onClick={() => {
                  window.location.assign('/admin');
                }}
              >
                Admin console
              </button>
            )}
            <button
              type="button"
              className="ghost-btn ghost-btn--text ghost-btn--danger top-nav__logout"
              onClick={handleLogout}
            >
              Log out
            </button>
            <button
              type="button"
              className="profile-chip"
              onClick={handleOpenAccount}
            >
              <div className="avatar">{avatarLetter}</div>
              <div className="profile-meta">
                <span className="profile-name">{displayName}</span>
                <span className="profile-role">{displayRole}</span>
              </div>
            </button>
          </>
        )}
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  clearSession,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopNav));
